import { render } from "./Duobao.vue?vue&type=template&id=1c225973&scoped=true"
import script from "./Duobao.vue?vue&type=script&lang=js"
export * from "./Duobao.vue?vue&type=script&lang=js"

import "./Duobao.vue?vue&type=style&index=0&id=1c225973&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c225973"]])

export default __exports__